import { useDispatch, useSelector } from 'react-redux';
import { selectLimitDamagePremRented } from '../../../../selectors/application';
import { setLimitDamagePremRented, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const DamagesToPremisesRentedSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const limitDamagePremRented = useSelector(selectLimitDamagePremRented);

  const coverageInfo = [{ coverage: 'Limit', limit: formatCurrency(limitDamagePremRented as number) }];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.LimitDamagePremRented, false));
    dispatch(setLimitDamagePremRented(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.LimitDamagePremRented, true));
    dispatch(setLimitDamagePremRented(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Damages to Premises Rented to You (Higher Limits)"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default DamagesToPremisesRentedSummaryCard;
